import Axios from "axios";

export const SelectNomCategorie = (cat, a, b, c, d, e) => {
  return (dispatch) => {
    Axios.get(
      `https://www.24-crm.tn/webservice/api/NOME?cat=${cat}&coddos=${a}&serveur=${b}&user=${c}&pwd=${d}&database=${e}`
    ).then((response) => {
      return dispatch({
        type: "NOMCATEGORIE_SELECT",
        payload: response.data,
      });
    });
  };
};
